import { ReservedWords } from "./reservedWords";

const qiReservedWords: any = {
  listings: {
    tr: ReservedWords.TR_QI_LISTING,
    en: ReservedWords.EN_QI_LISTING,
  },
  detail: {
    tr: ReservedWords.TR_QI_DETAIL,
    en: ReservedWords.EN_QI_DETAIL,
  },
};

export function getQIUrl(options: {
  domain?: string;
  lang: string;
  courseSlug?: string;
  subjectSlug?: string;
  questionSlug?: string;
  questionId?: number;
}): string {
  const isPath = !!options.domain;
  const isQDetail = options.questionSlug && options.questionId;

  let parts;
  if (isQDetail) {
    parts = [
      options.domain,
      options.lang === "tr" ? "tr" : undefined,
      qiReservedWords.detail[options.lang],
      `${options.questionSlug}-${options.questionId}`,
    ];
  } else {
    parts = [
      options.domain,
      options.lang === "tr" ? "tr" : undefined,
      qiReservedWords.listings[options.lang],
      options.courseSlug,
      options.subjectSlug,
    ];
  }

  const url = parts.filter((part) => !!part).join("/");

  return (isPath ? "" : "/") + url + "/";
}
